import { useEffect, useState } from "react";

// 以 model-viewer 的 canActivateAR 能力偵測判斷此裝置能否進行 AR 投放，
// 與 AR 投放（handleArProjection）共用同一套判斷邏輯：可投放 = 觸控操作，
// 不可投放 = 桌機滑鼠操作。
// canActivateAR 採 feature detection（webxr / scene-viewer / quick-look），
// 平板即使切換「桌面版網站」模式也能正確判斷；但需在 model-viewer 載入後才準確。
const useArAvailable = () => {
  const [arAvailable, setArAvailable] = useState(false);

  useEffect(() => {
    const viewer = document.querySelector("#myViewer");
    if (!viewer) return undefined;

    const update = () => setArAvailable(Boolean(viewer.canActivateAR));

    if (viewer.loaded) {
      update();
      return undefined;
    }

    viewer.addEventListener("load", update);
    return () => viewer.removeEventListener("load", update);
  }, []);

  return arAvailable;
};

export default useArAvailable;
